import React, { useState, useEffect } from 'react'
import { QrReader } from "react-qr-reader";

const EscaneoCamara = () => {
    const [data, setData] = useState("");
    const [texto, setTexto] = useState("")
    const [showScanner, setShowScanner] = useState(false);

    const handleScan = (result) => {
        if (result) {
            setData(result.text);
            setShowScanner(false);
        }
    };

    const handleError = (err) => {
        console.error(err);
    };

    const obtenerDatoEscaneo = async () => {
        try {
            const response = await fetch(`/p_escaneo`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: data,
                }),
            });
            const datos = await response.json();
            console.log(datos);
            setTexto(JSON.stringify(datos));
            if(datos.status === 1){
                window.location.href = `/escaneo/${datos.data[0].ID}`;
            }
        } catch (error) {
            setTexto(JSON.stringify(error));
            console.error(error);
        }
    }
    
    useEffect(() => {
        if (data != "") {
            setShowScanner(false);
            obtenerDatoEscaneo();
        }
    }, [data]);
    
    return (
        <div style={{ margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Escáner de Código QR</h2>
        
        {!showScanner ? (
          <button 
            onClick={() => setShowScanner(true)}
            style={{
              display: 'block',
              width: '100%',
              padding: '10px',
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Iniciar Escaneo
          </button>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <QrReader
              delay={300}
              onError={handleError}
              onResult={handleScan}
              style={{ width: '100%' }}
              constraints={{
                facingMode: 'environment'  // Esto fuerza el uso de la cámara trasera
              }}
            />
            <button 
              onClick={() => setShowScanner(false)}
              style={{
                marginTop: '10px',
                padding: '8px 16px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Detener
            </button>
          </div>
        )}

        {texto && (
          <div style={{ 
            marginTop: '20px',
            padding: '15px',
            backgroundColor: '#f5f5f5',
            borderRadius: '4px',
            wordBreak: 'break-word'
          }}>
            <h3>Datos del código QRS:</h3>
            <p>{texto}</p>
          </div>
        )}
        
      </div>
    );
};

export default EscaneoCamara;
